import { formatBytes } from "./formatBytes.js";
import { formatChatDate } from "./formatChatDate.js";
import { validateHashtag } from "./validateHashtag.js";
import { dateRangeIsNotSequential } from "./dateRangeIsNotSequential.js";
import { date } from "./date.js";
import { upload } from "./upload.js";
import  currentTheme from "./currentTheme.js";

window.formatBytes = formatBytes;
window.formatChatDate = formatChatDate;
window.validateHashtag = validateHashtag;
window.dateRangeIsNotSequential = dateRangeIsNotSequential;
window.date = date;
window.upload = upload;
window.currentTheme = currentTheme;
